import { Link } from '@tanstack/react-router';

import { m } from '@/paraglide/messages';

/** Shown for an unknown URL, by the router on a client-side navigation and as the `/404` page. */
export function NotFound() {
  return (
    <section className='mx-auto max-w-190 px-5 pt-24 pb-28 text-center sm:px-8 sm:pt-30 sm:pb-36'>
      <p className='mb-4 font-bold text-brand'>{m.not_found_label()}</p>
      <h1 className='mb-5 text-[clamp(38px,5vw,60px)] leading-[1.05] font-bold tracking-[-0.02em]'>
        {m.not_found_title()}
      </h1>
      <p className='text-body mx-auto mb-9 max-w-130 text-[19px] leading-relaxed'>{m.not_found_text()}</p>
      <div className='flex flex-wrap justify-center gap-3'>
        <Link
          to='/'
          className='inline-flex min-h-12 items-center justify-center gap-2.5 rounded-full bg-brand px-7 font-semibold text-white transition-colors hover:bg-[#1f4f8a] disabled:opacity-70'
        >
          {m.not_found_home()}
        </Link>
        <Link
          to='/contact'
          className='inline-flex min-h-12 items-center justify-center gap-2.5 rounded-full border border-[#cfd7e2] bg-white px-7 font-semibold transition-colors hover:border-brand hover:text-brand'
        >
          {m.not_found_contact()}
        </Link>
      </div>
    </section>
  );
}
